import { RawDraftContentState } from "draft-js";

export const getDraftJsText = (draftJsonString: string): string => {
  let result: string;

  try {
    const draftJson: RawDraftContentState = JSON.parse(draftJsonString);

    result = draftJson.blocks.map(block => block.text).join(" ");
  } catch (err) {
    return draftJsonString;
  }

  return result;
};
